// This file was automatically generated from appchart.letters.unreadAlertNotification.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.letters.unreadAlertNotification');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letters');
goog.require('el8.template.render.signOff');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.feedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isSendToPatient) ? '<div class="el8FeedItemIconPtLetterNotification"></div>' : (opt_data.isReferralLetter) ? '<div class="el8FeedItemIconReferralNotification"></div>' : '<div class="el8FeedItemIconLetterNotification"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.resendLetterDialogContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="update-unread-alert-notification" class="el8DialogContainer padb30"><div class="el8FieldSection"><div class="el8Wrap"><div class="letter-summary"></div></div></div><div class="el8FieldSection"><div class="el8Wrap"><p>Notify me again if not opened</p></div></div><div class="el8FieldSection"><div class="el8Wrap"><select class="w100" name="unreadAlertInDays">');
  el8.template.appchart.letters.unreadAlertNotification.notificationSelection({showDisabledChoice: true, showSpecificDate: false}, output);
  output.append('</select></div></div><div class="el8FieldSection resend-include-attachments-section"><div class="el8Wrap"><label class="el8label el8CheckMark"><input name="includeAttachments" type="checkbox" class="options" />Include all attachments in fax</label></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.notificationSelection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.showSpecificDate) ? '<option value="specificDate">by a specific date</option>' : '', '<option value="1">in 1 day</option><option value="2">in 2 days</option><option value="3">in 3 days</option><option value="4">in 4 days</option><option value="5">in 5 days</option><option value="6">in 6 days</option><option value="7">in 1 week</option><option value="14">in 2 weeks</option><option value="21">in 3 weeks</option><option value="28">in 4 weeks</option><option value="60">in 2 months</option><option value="90">in 3 months</option>', (opt_data.showDisabledChoice) ? '<option value="none">don\'t notify me</option>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.newNotificationDialogContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="update-unread-alert-notification" class="el8DialogContainer padb30"><div class="el8FieldSection"><div class="el8Wrap"><div class="letter-summary"></div></div></div><div class="el8FieldSection"><div class="el8Wrap"><p>Notify me again if not opened</p></div></div><div class="el8FieldSection"><div class="el8Wrap"><select class="w100" name="unreadAlertInDays">');
  el8.template.appchart.letters.unreadAlertNotification.notificationSelection({showDisabledChoice: false, showSpecificDate: false}, output);
  output.append('</select></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.letterSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8Bold">', (opt_data.letter.isReferralLetter) ? 'Referral' : 'Letter', ' to ', soy.$$escapeHtml(opt_data.letter.displayTo), ' ', (opt_data.letter.isReferralLetter && opt_data.letter.referralOrder.specialtyName) ? '(' + soy.$$escapeHtml(opt_data.letter.referralOrder.specialtyName) + ')' : '', '</p><p class="el8GrayText">Written: ', (soy.$$escapeHtml(opt_data.letter.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.letter.signDate)) : ''), '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.feedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.linkToDetail) ? (opt_data.letter.referralOrder) ? '<a class="item-details-trigger" data-id="' + soy.$$escapeHtml(opt_data.letter.referralOrder.id) + '">' : '<a class="item-details-trigger" data-id="' + soy.$$escapeHtml(opt_data.letter.id) + '">' : '', (opt_data.letter.isReferralLetter) ? 'Referral' : 'Letter', ' to ', soy.$$escapeHtml(opt_data.letter.displayTo), ' ', (opt_data.letter.isReferralLetter && opt_data.letter.referralOrder.specialtyName) ? '(' + soy.$$escapeHtml(opt_data.letter.referralOrder.specialtyName) + ')' : '', (opt_data.letter.isReferralLetter) ? ' for: ' + soy.$$escapeHtml(opt_data.letter.body) : (opt_data.letter.subject) ? ' re: ' + soy.$$escapeHtml(opt_data.letter.subject) : '', (opt_data.linkToDetail) ? '</a>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.chartFeedItemText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.unreadLetterNotification.actionTaken == 'newNotification') ? (opt_data.unreadLetterNotification.newUnreadAlertDate) ? 'Will notify again if still not opened by ' + (soy.$$escapeHtml(opt_data.unreadLetterNotification.newUnreadAlertDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.unreadLetterNotification.newUnreadAlertDate)) : '') : 'Will notify again if still not opened ' + soy.$$escapeHtml(opt_data.unreadLetterNotification.newUnreadAlertInDays) + ' days from today' : (opt_data.unreadLetterNotification.actionTaken == 'resend') ? 'Re-sent ' + ((! opt_data.letter.isSendToPatient) ? 'to fax: ' + soy.$$escapeHtml(opt_data.letter.toNumber) + ' ' : '') + 'at ' + (soy.$$escapeHtml(opt_data.unreadLetterNotification.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.unreadLetterNotification.signDate)) : '') : (opt_data.unreadLetterNotification.actionTaken == 'resendWithAttach') ? 'Re-sent, all attachments faxed ' + ((! opt_data.letter.isSendToPatient) ? 'to fax: ' + soy.$$escapeHtml(opt_data.letter.toNumber) + ' ' : '') + 'at ' + (soy.$$escapeHtml(opt_data.unreadLetterNotification.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.unreadLetterNotification.signDate)) : '') : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.chartFeedItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.unreadLetterNotification.actionTaken != 'acknowledged') {
    output.append('<p class="el8DescriptionSnippet el8AppText">');
    el8.template.appchart.letters.unreadAlertNotification.chartFeedItemText(opt_data, output);
    output.append('</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.unsignedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<!-- ', soy.$$escapeHtml(opt_data.unreadLetterNotification.unreadAlertInDays), ' -->', (! opt_data.letter.isSendToPatient && opt_data.letter.toNumber) ? 'Sent to fax ' + soy.$$escapeHtml(opt_data.letter.toNumber) + ' at ' + (soy.$$escapeHtml(opt_data.letter.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.letter.signDate)) : '') : 'Sent at ' + (soy.$$escapeHtml(opt_data.letter.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.letter.signDate)) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.homeFeedItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LetterHeaderWrap"><p class="el8333 el8SingleLineText"><span class="el8Bold">');
  el8.template.appchart.letters.unreadAlertNotification.feedSummary(soy.$$augmentData(opt_data, {linkToDetail: false}), output);
  output.append('</span></p><div class="fr ebs-pull-right"><button type="button" class="el8button el8ShortButton ebs-btn ebs-btn-default ebs-btn-sm letter-toggle-collapse-trigger">show more</button></div><p class="el8SingleLineText">Not opened by recipient. ');
  el8.template.appchart.letters.unreadAlertNotification.unsignedSummary(opt_data, output);
  output.append('</p></div><div class="letter-collapsible-section"><div class="el8SectionDivider el8FieldSection mt5 ebs-form-horizontal"><div class="el8FieldSection mt10 ebs-form-group"><label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2">To:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize ebs-col-sm-10"><span class="el8Bold">');
  el8.template.ptdata.letters.recipient(opt_data, output);
  output.append('</span></div></div>', (! opt_data.letter.isReferralLetter) ? '<div class="el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2">Re:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize ebs-col-sm-10">' + ((opt_data.letter.subject) ? (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.subject) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.subject)) : soy.$$escapeHtml(opt_data.letter.subject)) : '(no subject)') + '</div></div>' : '', '</div>');
  if (opt_data.letter.isReferralLetter) {
    output.append('<div class="el8FieldSection mb20 ebs-form-horizontal">', (opt_data.letter.body) ? '<div class="el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium ebs-control-label ebs-control-label ebs-col-sm-2">Reason:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardLineHeight el8StandardFontSize ebs-col-sm-10">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.body)) : soy.$$escapeHtml(opt_data.letter.body))) + '</div></div>' : '', '<div class="el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium ebs-control-label ebs-control-label ebs-col-sm-2">Auth For:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize ebs-col-sm-10">', soy.$$escapeHtml(opt_data.letter.referralOrder.authorizationFor), '</div></div>', (opt_data.letter.referralOrder.authNumber) ? '<div class="el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium ebs-control-label ebs-control-label ebs-col-sm-2">Auth #:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize ebs-col-sm-10">' + soy.$$escapeHtml(opt_data.letter.referralOrder.authNumber) + '</div></div>' : '');
    if (opt_data.letter.referralOrder.icd10CodeObjs && opt_data.letter.referralOrder.icd10CodeObjs.length) {
      var icd10ObjList3754 = opt_data.letter.referralOrder.icd10CodeObjs;
      var icd10ObjListLen3754 = icd10ObjList3754.length;
      for (var icd10ObjIndex3754 = 0; icd10ObjIndex3754 < icd10ObjListLen3754; icd10ObjIndex3754++) {
        var icd10ObjData3754 = icd10ObjList3754[icd10ObjIndex3754];
        output.append('<div class="el8FieldSection ebs-form-group">', (icd10ObjIndex3754 == 0) ? '<label class="el8label el8FieldMedium ebs-control-label ebs-control-label ebs-col-sm-2">ICD-10:</label>' : '<label class="el8label el8FieldMedium ebs-control-label ebs-control-label ebs-col-sm-2"></label>', '<div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize ebs-col-sm-10">', soy.$$escapeHtml(icd10ObjData3754.code), (icd10ObjData3754.description) ? ' - ' + soy.$$escapeHtml(icd10ObjData3754.description) : '', '</div></div>');
      }
    }
    if (opt_data.letter.referralOrder.icd9CodeObjs && opt_data.letter.referralOrder.icd9CodeObjs.length) {
      var icd9ObjList3771 = opt_data.letter.referralOrder.icd9CodeObjs;
      var icd9ObjListLen3771 = icd9ObjList3771.length;
      for (var icd9ObjIndex3771 = 0; icd9ObjIndex3771 < icd9ObjListLen3771; icd9ObjIndex3771++) {
        var icd9ObjData3771 = icd9ObjList3771[icd9ObjIndex3771];
        output.append('<div class="el8FieldSection ebs-form-group">', (icd9ObjIndex3771 == 0) ? '<label class="el8label el8FieldMedium ebs-control-label ebs-control-label ebs-col-sm-2">ICD-9:</label>' : '<label class="el8label el8FieldMedium ebs-control-label ebs-control-label ebs-col-sm-2"></label>', '<div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize ebs-col-sm-10">', soy.$$escapeHtml(icd9ObjData3771.code), (icd9ObjData3771.description) ? ' - ' + soy.$$escapeHtml(icd9ObjData3771.description) : '', '</div></div>');
      }
    }
    output.append('</div>');
  } else {
    output.append('<div class="el8FieldSection">', (opt_data.letter.body) ? '<p class="letter-body el8SingleLineText mt10 mb20">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.letter.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.letter.body)) : soy.$$escapeHtml(opt_data.letter.body))) + '</p>' : '', '</div>');
  }
  output.append('<div class="mt5">');
  if (opt_data.excludeAttachmentDetails) {
    output.append('<div class="padv5"><p class="el8AttachmentListChart el8GrayText el8ItalicText">', soy.$$escapeHtml(opt_data.letter.attachments.length), ' attachment', (opt_data.letter.attachments.length != 1) ? 's' : '', ' (see chart for details)</p></div>');
  } else if (opt_data.letter.attachments.length) {
    output.append('<p class="el8SmallHeading">Attachments</p>');
    el8.template.ptdata.letters.attachmentSection(soy.$$augmentData(opt_data.letter, {noAttachmentLinks: opt_data.noAttachmentLinks}), output);
  }
  output.append('<div class="mb5">');
  el8.template.render.signOff.summary(opt_data.letter, output);
  output.append('</div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.signOffSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8SignoffText">');
  el8.template.appchart.letters.unreadAlertNotification.signOffSummaryText(opt_data, output);
  output.append('</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.signOffSummaryText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signUserBehalfName) {
    el8.template.appchart.letters.unreadAlertNotification.signOffAction(opt_data, output);
    output.append(' for ', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserName)) : soy.$$escapeHtml(opt_data.signUserName)), ' by ', soy.$$escapeHtml(opt_data.signUserBehalfName), ' on ', (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''));
  } else {
    if (opt_data.signUserType == 'OfficeStaff') {
      output.append('Filed by');
    } else {
      el8.template.appchart.letters.unreadAlertNotification.signOffAction(opt_data, output);
      output.append(' by');
    }
    output.append(' ', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserName)) : soy.$$escapeHtml(opt_data.signUserName)), ' on ', (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''));
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.unreadAlertNotification.signOffAction = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.unreadLetterNotification.actionTaken == 'acknowledged') ? 'Acknowledged and signed off' : 'Signed off');
  if (!opt_sb) return output.toString();
};
